const resourceSvrUrl = 'https://resources.pearsonactivelearn.com/'
const filePath = 'current/OPS'

export { resourceSvrUrl, filePath }
